<template>
  <v-container>
    <v-row justify="space-between" align="center">
      <v-col>
        <span>
          <v-tooltip max-width="30vw" v-if="node.meta.tooltip" left>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                :class="{ 'text-h6': isRoot, 'font-weight-medium': !isRoot }"
                v-text="node.name"
              ></span>
            </template>
            <span>{{ node.meta.tooltip }}</span>
          </v-tooltip>

          <span
            v-else
            :class="{ 'text-h6': isRoot, 'font-weight-medium': !isRoot }"
            v-text="node.name"
          ></span>
        </span>
        <span class="text-body-2 ml-3 vertical">
          <v-tooltip max-width="30vw" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="showAddToGroup()"
                v-bind="attrs"
                v-on="on"
                color="info"
                icon
                x-small
              >
                <v-icon small>mdi-select-group</v-icon>
              </v-btn>
            </template>
            <span>Edit View</span>
          </v-tooltip>
          <span
            class="text-body-2"
            v-if="
              node.meta.periodic_group &&
                node.meta.periodic_group.length &&
                !showGroupEditControls
            "
          >
            in Views {{ this.node.meta.periodic_group.join(", ") }}
          </span>

          <EditGroup
            v-if="showGroupEditControls"
            :node="node"
            :groups="groups"
            :selectedRecord="selectedRecord"
            :showGroupEditControls.sync="showGroupEditControls"
          />
        </span>
        <span class="text-body-2 ml-3 vertical">
          <v-tooltip max-width="30vw" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="showEditEvents()"
                v-bind="attrs"
                v-on="on"
                color="info"
                icon
                x-small
              >
                <v-icon small>mdi-clipboard-edit-outline</v-icon>
              </v-btn>
            </template>
            <span>Edit Events</span>
          </v-tooltip>
          <span
            class="text-body-2"
            v-if="
              node.meta.events &&
                node.meta.events.length &&
                !showEventEditControls
            "
          >
            in Events {{ this.node.meta.events.join(", ") }}
          </span>

          <EditEvent
            v-if="showEventEditControls"
            :node="node"
            :events="events"
            :selectedRecord="selectedRecord"
            :showEventEditControls.sync="showEventEditControls"
          />
        </span>
      </v-col>
      <div>
        <span v-if="hasScore(node._id)" class="text-subtitle-2">
          Score: {{ getScore(node._id) }}
        </span>
        <span class="text-body-2" v-if="node.children.length">
          <v-tooltip max-width="30vw" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on" @click="scoreCat()" x-small>
                <v-icon small color="info">mdi-format-list-numbered-rtl</v-icon>
              </v-btn>
            </template>
            <span>Score this category and its children</span>
          </v-tooltip>
        </span>
        <span class="font-weight-light text-body-2">
          <v-tooltip max-width="30vw" bottom v-if="node.value.length > 0">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                {{ dateTimeLabel(node.value[node.value.length - 1], false) }}
              </span>
            </template>
            <span>
              <span v-if="getAuthor()" class="font-weight-light text-body-2">
                Last changed by {{ getAuthor() }} on
              </span>
              {{
                reformatTimestamp(
                  node.value[node.value.length - 1].eventTimestamp,
                  true
                )
              }}
            </span>
          </v-tooltip>
        </span>
        <v-tooltip
          max-width="30vw"
          v-if="!showMoreValues && node.value.length > 1"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="editMode"
              @click="toggleShowMoreValues()"
              v-bind="attrs"
              v-on="on"
              text
              color="info"
              icon
            >
              <v-icon>mdi-table</v-icon>
            </v-btn>
          </template>
          <span>Show 5 Most Recent entries</span>
        </v-tooltip>

        <v-tooltip max-width="30vw" v-if="showMoreValues" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="editMode"
              @click="toggleShowMoreValues()"
              v-bind="attrs"
              v-on="on"
              text
              color="info"
              icon
            >
              <v-icon>mdi-table-cancel</v-icon>
            </v-btn>
          </template>
          <span>Hide 5 Most Recent entries</span>
        </v-tooltip>

        <v-tooltip
          max-width="30vw"
          v-if="isGraphable && !showGraph && node.value.length > 3"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="editMode"
              @click="ToggleGraph()"
              v-bind="attrs"
              v-on="on"
              text
              color="info"
              icon
            >
              <v-icon>mdi-chart-line</v-icon>
            </v-btn>
          </template>
          <span>Show Graph</span>
        </v-tooltip>
        <v-tooltip max-width="30vw" v-if="isGraphable && showGraph" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="editMode"
              @click="ToggleGraph()"
              v-bind="attrs"
              v-on="on"
              text
              color="info"
              icon
            >
              <v-icon>mdi-close-box-multiple-outline</v-icon>
            </v-btn>
          </template>
          <span>Hide Graph</span>
        </v-tooltip>
      </div>
    </v-row>
    <v-row no-gutters>
      <v-col col="12" class="pa-0" v-if="!editMode">
        <div v-if="!showMoreValues">
          <TypeFactory
            :node="node"
            :editMode="editMode"
            :editIndex="selectedIndex"
            :selectedRecord="selectedRecord"
            :isRoot="isRoot"
            :createMode="false"
            class="mt-3"
          />
        </div>

        <div v-if="showMoreValues" class="pt-2">
          <PeriodicViewer :values="node.value" :node="node" />
        </div>
        <div v-if="isGraphable && showGraph" class="pt-2">
          <Charts :node="node" :isEmbedded="true" />
        </div>
      </v-col>
    </v-row>

    <span v-if="editMode">
      <v-row class="pl-2 flex-column">
        <v-col class="pb-0">
          <TypeFactory
            :node="node"
            :editMode="editMode"
            :editIndex="selectedIndex"
            :selectedRecord="selectedRecord"
            :isRoot="isRoot"
            :createMode="false"
            class="mt-3"
            v-on:resetform="resetForm()"
          />
        </v-col>
        <v-col
          col
          v-if="showDateMode"
          class="mt-3 pa-0 d-flex flex-column justify-start"
        >
          <div class="d-flex flex-row">
            <v-menu
              ref="menu"
              v-model="showDatePicker"
              :close-on-content-click="false"
              :return-value.sync="showDatePicker"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  @click="showDatePicker = !showDatePicker"
                  class="mr-2 mt-3"
                >
                  <v-icon>mdi-calendar-plus</v-icon>
                </v-btn>
              </template>
              <div class="d-flex flex-row menu-background">
                <div class="d-flow flow-column">
                  <v-date-picker
                    v-model="pickerDate"
                    no-title
                    scrollable
                    show-adjacent-months
                    :max="today"
                  ></v-date-picker>
                  <div class="text-center">
                    <v-btn
                      text
                      color="secondary"
                      @click="showDatePicker = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="addValuesFromDatepicker(pickerDate, pickerTime)"
                    >
                      OK
                    </v-btn>
                  </div>
                </div>
                <v-spacer></v-spacer>
                <v-time-picker
                  v-model="pickerTime"
                  scrollable
                  ampm-in-title
                  format="ampm"
                  :allowed-minutes="[0, 15, 30, 45]"
                ></v-time-picker>
              </div>
            </v-menu>

            <!-- /// start edit event time components -->
            <v-menu
              ref="menu"
              v-model="showEditDatePicker"
              :close-on-content-click="false"
              :return-value.sync="showEditDatePicker"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  @click="showEditDatePicker = !showEditDatePicker"
                  class="mr-2 mt-3"
                >
                  <v-icon>mdi-calendar-edit</v-icon>
                </v-btn>
              </template>
              <div class="d-flex flex-row menu-background">
                <div class="d-flow flow-column">
                  <v-date-picker
                    v-model="pickerEditDate"
                    no-title
                    scrollable
                    show-adjacent-months
                  ></v-date-picker>
                  <div class="text-center">
                    <v-btn
                      text
                      color="secondary"
                      @click="showEditDatePicker = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="
                        editValuesFromDatepicker(pickerEditDate, pickerEditTime)
                      "
                    >
                      OK
                    </v-btn>
                  </div>
                </div>
                <v-spacer></v-spacer>
                <v-time-picker
                  v-model="pickerEditTime"
                  scrollable
                  ampm-in-title
                  format="ampm"
                ></v-time-picker>
              </div>
            </v-menu>
            <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  @click="deleteValuesFromDatePicker()"
                  class="mr-2 mt-3"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-menu>
            <v-select
              prepend-icon="mdi-pencil-plus"
              @click:prepend="addValues"
              v-model="selectedValue"
              :items="reverseSortedValues()"
              item-text="eventTimestamp"
              label="Date and time"
              return-object
            >
              <template v-slot:selection="data">
                {{ dateTimeLabel(data.item, true) }}
              </template>
              <template v-slot:item="data">
                <v-list-item-content
                  v-text="dateTimeLabel(data.item, true)"
                ></v-list-item-content>
              </template>
            </v-select>
          </div>
        </v-col>
      </v-row>
    </span>
  </v-container>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import PeriodicViewer from "./periodic-viewer/PeriodicViewer";
import Charts from "../charts/Charts";
import TypeFactory from "../TypeFactory";
import EditEvent from "../EditEvents";
import EditGroup from "../EditGroups";
import { scoreNode } from "../../../utils/api";

import findIndex from "lodash/findIndex";
import isArray from "lodash/isArray";

export default {
  name: "Periodic",
  components: {
    PeriodicViewer,
    TypeFactory,
    EditEvent,
    EditGroup,
    Charts,
  },
  props: {
    node: Object,
    editMode: Boolean,
    selectedRecord: Object,
    isRoot: Boolean,
    showDateMode: Boolean,
  },
  watch: {
    editMode: function(newVal, oldVal) {
      if (newVal) {
        this.selectedValue = this.node.value[this.node.value.length - 1];
      }
    },
    showEditDatePicker: function() {
      this.pickerEditDate = new Date(this.selectedValue.timestamp)
        .toISOString()
        .substr(0, 10);
      this.pickerEditTime =
        new Date(this.selectedValue.timestamp).getHours() +
        ":" +
        new Date(this.selectedValue.timestamp).getMinutes();
    },
  },

  computed: {
    ...mapState({
      currentlyFullRecordId: (state) =>
        state.records.currentlySelectedTab.recordId,
      currentRecordDateTimeStamp: (state) =>
        state.records.currentlySelectedTab.datetime,
    }),
    ...mapGetters({
      events: "getEventsGroupByTab",
      groups: "getGroupByTab",
      getScore: "getScoreByNodeID",
      hasScore: "doesScoreExist",
    }),
    latestPeriodicValue() {
      if (isArray(this.node.value)) {
        const lastEntry = this.node.value.length - 1;
        const latest = this.node.value[lastEntry];
        if (isArray(latest.val)) {
          const sep = this.node.meta.separator ? this.node.meta.separator : ",";
          return latest.val.join(sep);
        } else {
          return latest.val;
        }
      } else {
        return this.node.value;
      }
    },
    selectedIndex() {
      let index = -1;
      if (this.selectedValue) {
        index = findIndex(this.node.value, {
          timestamp: this.selectedValue.timestamp,
        });
      }
      return index === -1 ? 0 : index;
    },
    isGraphable() {
      return (
        this.node.meta.type === "numeric" ||
        this.node.meta.type === "numeric-array" ||
        this.node.meta.type === "numeric-scale"
      );
    },
    computedpickerEditDate() {
      this.pickerEditDate = new Date(this.selectedValue.timestamp)
        .toISOString()
        .substr(0, 10);
      this.pickerEditTime = new Date(this.selectedValue.timestamp)
        .toISOString()
        .substr(11, 5);
      return "";
    },
  },
  data() {
    return {
      today: new Date().toISOString(),
      showDatePicker: false,
      pickerDate: null,
      pickerTime: null,
      showEditDatePicker: false,
      pickerEditDate: null,
      pickerEditTime: null,
      showMoreValues: false,
      showGraph: false,
      showGroupEditControls: false,
      showEventEditControls: false,
      newPeriodicGroup: this.node.meta.periodic_group,
      selectedValue: this.node.value[this.node.value.length - 1],
    };
  },

  methods: {
    arrayData(idx) {
      return this.node.value[idx];
    },
    changeValue(e, node, index) {
      if (!e) {
        return;
      }
      node.value[index] = e;
      this.$root.$emit("edit:update");
    },
    toggleShowMoreValues() {
      this.showGraph = false;
      this.showMoreValues = !this.showMoreValues;
    },
    ToggleGraph() {
      this.showMoreValues = false;
      this.showGraph = !this.showGraph;
    },
    reformatTimestamp(timestamp, showTime = false) {
      return moment(timestamp).format(
        showTime ? "MMM Do YYYY, h:mm a" : "MMM Do YYYY"
      );
    },
    dateTimeLabel(value, showTime = false) {
      if (value) {
        const theTimestamp = value.eventTimestamp
          ? value.eventTimestamp
          : value.timestamp;
        if (theTimestamp) {
          return this.formattedDateTimeLabel(
            theTimestamp,
            value.event,
            showTime
          );
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    formattedDateTimeLabel(timestamp, event, showTime = false) {
      return `${this.reformatTimestamp(timestamp, showTime)}${
        event ? ` (${event})` : ""
      }`;
    },
    reverseSortedValues() {
      return this.node.value.concat().reverse();
    },
    addValues() {
      const timestamp = new Date(this.currentRecordDateTimeStamp);
      this.addValuesAtDate(timestamp, false);
    },
    buildTimestamp(date, time) {
      const datePieces = date.split("-");
      const timePeices = time.split(":");
      // We have to build the date and time in pieces since otherwise it will default to UTC
      const timestamp = new Date(
        datePieces[0],
        datePieces[1] - 1,
        datePieces[2],
        timePeices[0],
        timePeices[1]
      );
      return timestamp;
    },
    addValuesFromDatepicker(date, time) {
      const timestamp = this.buildTimestamp(date, time);
      this.addValuesAtDate(timestamp, true);
      this.showDatePicker = false;
    },
    addValuesAtDate(timestamp, fromCalendar = false) {
      const now = new Date().toISOString();

      // If this node uses arrays of more than one element, create the proper length array
      const newValueLen = this.node.meta.value_name
        ? this.node.meta.value_name.length
        : 1;
      const newValue = {
        event: "",
        eventTimestamp: timestamp.toISOString(),
        // If we're setting a date/time from the calendar use that for both timestamps
        timestamp: fromCalendar ? timestamp : timestamp.toISOString(),
        val: new Array(newValueLen),
      };
      if (this.node.meta.min) {
        newValue.val.fill(this.node.meta.min);
      }
      this.node.value.push(newValue);
      this.selectedValue = this.node.value[this.node.value.length - 1];
      this.showDatePicker = false;
    },
    editValuesFromDatepicker(editedDate, editedTime) {
      const timestamp = this.buildTimestamp(editedDate, editedTime);

      const editedValue = {
        event: "",
        eventTimestamp: timestamp.toISOString(),
        // If we're setting a date/time from the calendar use that for both timestamps
        timestamp: timestamp.toISOString(),
        val: this.selectedValue.val,
      };

      this.node.value[
        this.node.value.indexOf(this.selectedValue)
      ] = editedValue;
      this.selectedValue = this.node.value[this.node.value.length - 1];
      this.showEditDatePicker = false;
    },
    deleteValuesFromDatePicker() {
      if (
        !window.confirm(
          `Are you sure you want to remove event entry? Delete will not be completed until you save the record`
        )
      ) {
        return;
      }

      Vue.delete(this.node.value, this.node.value.indexOf(this.selectedValue));
      this.selectedValue = this.node.value[this.node.value.length - 1];
    },
    resetForm() {
      this.$emit("resetform");
    },
    showAddToGroup() {
      this.showGroupEditControls = !this.showGroupEditControls;
    },
    showEditEvents() {
      this.showEventEditControls = !this.showEventEditControls;
    },
    async scoreCat() {
      const response = await scoreNode({
        rec_id: this.selectedRecord._id,
        node_id: this.node._id,
      });
      if (response?.Success) {
        this.$store.dispatch("addNotification", {
          type: "success",
          message: `Scored category ${this.node.name}`,
        });
        this.$store.commit("SET_SCORE_FOR_NODE", {
          node_id: this.node._id,
          score: response.Success.total,
        });
      } else {
        this.$store.dispatch("addNotification", {
          type: "errorMessage",
          message: `Failed to score category ${this.node.name}`,
        });
      }
    },
    getAuthor() {
      if (this.node.authorName) {
        return this.node.authorName;
      }
      if (Array.isArray(this.node.value)) {
        const latest = this.node.value[this.node.value.length - 1];
        if (latest?.authorName) {
          return latest.authorName;
        }
      }
      return null;
    },
  },
};
</script>

<style lang="scss">
.tree-text {
  width: 90%;
}
.full-width {
  width: 100%;
}
.vertical {
  vertical-align: text-bottom;
}
.menu-background {
  background-color: #fff;
}
</style>
